/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

"use strict";

/*
 * Combain name & localization message to emit to toast.js
 */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "desktoptoast",
	init: init,
	listeners: listeners,
	triggers: triggers,
});

function init() {
	this.push("");
	this._people = {};
	this._localization = {};
}

function listeners() {
	return {
		"people:updated": handle_people_update,
		"localization:updated": handle_localization_updated,
	};
}

function triggers() {
	return {
		"conference:busy": show_conference_busy_message,
	};
}

function handle_people_update(people) {
	this._people = people;
}

function handle_localization_updated(localization) {
	this._localization = localization;
}

function show_conference_busy_message(data) {
	var who = data.who;
	var people = this._people;
	var whoData = people[who];
	var message = "outgoing.messageBusy";
	this.emit("toast:trigger:show", {
		content: message,
		arguments: {
			fname: whoData.fname,
			lname: whoData.lname
		}
	});
}
